export enum DrawingLibraryViewMode {
  THUMBNAILS = 'THUMBNAILS',
  THUMBNAILS_WITH_CONFIGURATIONS = 'THUMBNAILS_WITH_CONFIGURATIONS',
  TABLE = 'TABLE'
}
